/**
 * En-têtes d'authentification de l'API Engage (API-R1).
 *
 * Le serveur tient le contexte de la session (site, rôle, persona, appareil) et
 * le signale par `bound: true` dans le bundle rendu à la connexion, au SSO ou à
 * l'échange d'un code. Le jeton suffit ; la langue de l'interface part dans
 * `Accept-Language`, le serveur la suit à chaque appel. Le bundle stocké ne sert
 * qu'à l'affichage et au WebSocket (`session_id`) : il n'est jamais renvoyé.
 *
 * L'ancien protocole (bundle signé par la signkey à chaque requête) est retiré
 * côté serveur. Un bundle stocké sans `bound` est celui d'une session ouverte
 * avant ce retrait : aucun en-tête d'authentification n'est envoyé, l'API répond
 * 403 sur les routes protégées et les intercepteurs ramènent à la connexion.
 */
export interface EngageBundle {
    site?: string;
    language?: string;
    device?: string;
    persona?: string;
    role?: string;
    session_id?: number | string;
    hash?: string;
    bound?: boolean;
}

export function readStoredBundle(): EngageBundle | null {
    try {
        return JSON.parse(localStorage.getItem('x-bundle-recurring'));
    } catch {
        return null;
    }
}

export function isBoundBundle(bundle: EngageBundle | null): boolean {
    return !!(bundle && bundle.bound);
}

/** En-têtes d'authentification d'un appel à l'API, pour `HttpHeaders` ou `setHeaders`. */
export function engageAuthHeaders(bundle: EngageBundle | null, accessToken: string): Record<string, string> {
    if (!bundle || !isBoundBundle(bundle) || !accessToken) {
        return {};
    }
    const headers: Record<string, string> = { Authorization: 'Bearer ' + accessToken };
    const language = bundle.language || localStorage.getItem('language');
    if (language) {
        headers['Accept-Language'] = language;
    }
    return headers;
}
